import endpoints from 'utils/api/endpoints';
import apiConfig from 'utils/api/config';
import { env } from 'config/app.config';

const PaymentFrame = () => {
	const url = endpoints.omantelApi.paymentSite.url;
	const protocol = apiConfig.protocol[env];
	const source = apiConfig.sources.omantelApi[env];
	const PAYMENT_URL = `${protocol}${source}${url}`;

	window.location.href = PAYMENT_URL;
	return null;
};

export default PaymentFrame;
